/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useRef, useCallback, useMemo } from "react";
import { Dropdown } from "react-bootstrap";
import LogicContext from "../../Context/LogicContext";
import { SetPaymentMadeAtom, GetPaymentMadeAtom } from "../../store/paymentMadeAtom";
import CurrencyFormat from "react-currency-format";
import Tooltip from "@mui/material/Tooltip";
import RestartAlt from "@mui/icons-material/RestartAlt";
import { useState } from "react";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import { useLocation, useNavigate } from "react-router-dom";
import { IoMdRefresh } from "react-icons/io";
import { useForm } from "react-hook-form";
import moment from "moment";
import { FaPlus } from "react-icons/fa";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import { formatCustomDate } from "../../helpers/formatCustomDate";
import { paymentMadeService } from "../../services/paymentMade";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
import StatusBadge from "../../generals/StatusBadge";

const PaymentMadeMainPage = () => {
  const { pathname } = useLocation();
  const { register, setValue, getValues, handleSubmit, reset, formState: { errors } } = useForm();
  const navigate = useNavigate();
  const url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];
  const { showToast } = useContext(LogicContext); // Select only needed context value
 
  const setPaymentMadeAtom  = SetPaymentMadeAtom();
  const getPaymentMadeAtom  = GetPaymentMadeAtom();
  const myPromiseModal = createModal(GeneralModal);
  const [tableData, setTableData] = useState([]);
  const [itemSelected, setItemSelected] = useState([]);
  const [searchText, setSearchText] = useState("");
  

  // Memoized columns to prevent recreation
  const columns = useMemo(
    () => [
      {
        title: "Ref",
        key: "payment_ref_no",
        dataIndex: "payment_ref_no",
        className: "text-primary",
        sorter: (a, b) => (a?.payment_ref_no ?? "") - (b?.payment_ref_no ?? ""),
      },
      {
        title: "Pay No",
        dataIndex: "payment_number",
        sorter: (a, b) => (a?.payment_number ?? "").localeCompare(b?.payment_number ?? ""),
      },
      {
        title: "Ref NO.",
        dataIndex: "reference_number",
        sorter: (a, b) => (a?.reference_number ?? "").localeCompare(b?.reference_number ?? ""),
      },
      {
        title: "Amount",
        dataIndex: "total_payment_amount",
        sorter: (a, b) => (formatCustomNumber(a?.total_payment_amount) ?? "") - (formatCustomNumber(a?.total_payment_amount) ?? ""),

      },

  
      {
        title: "Date",
        dataIndex: "payment_date",
        sorter: (a, b) => (a?.payment_date ?? "").localeCompare(a?.payment_date ?? ""),
        render: (record) => <span> {formatCustomDate(record)} </span>,
        

      },
   
      {
        title: "Status",
        dataIndex: "payment_status_name",
        sorter: (a, b) => (a?.payment_status_name ?? "").localeCompare(b?.payment_status_name ?? ""),
        render: (value, row) => (
          <StatusBadge statusId={row?.payment_status_id} statusName={value} />
        ),
      },
    ],
    []
  );

  // Set table data from global state
  useEffect(() => {
    if (getPaymentMadeAtom?.payment_info?.length > 0) {
      setTableData(getPaymentMadeAtom.payment_info || []);
    }else{
      getPaymentMadeFromAPI();
    }
    return () => {
    };
  }, []);


  // Handle session-based reload
  useEffect(() => {
    if (sessionStorage.getItem("reloadPage") === "true") {
      sessionStorage.removeItem("reloadPage");
      getPaymentMadeFromAPI();
    }
  }, []);


  // Fetch sales order list with abortable request
  const getPaymentMadeFromAPI = useCallback(async () => {
   
    try {
      const response = await paymentMadeService.paymentMadeList();
      const serverData =  response.data;
      if ( response?.data !== undefined) {

        
        const payment_info = serverData?.payment_info?.length ?  serverData?.payment_info : [];
        const pay_List = serverData?.payment_through?.length ?  serverData?.payment_through : [];
        const vendor = serverData?.vendor?.length ?  serverData?.vendor : [];
        const tax_info = serverData?.vendor?.length ?  serverData?.tax_info : [];
        setPaymentMadeAtom({...serverData, payment_through: pay_List, vendor:vendor, payment_info: payment_info, tax_info:tax_info });
      setTableData(response.data?.payment_info || []);

      }
    } catch (err) {
        console.error(err);
    }
   
  }, [setPaymentMadeAtom]);





  const selectedTableItems = useCallback((itemList) => {
    setItemSelected(itemList);
  }, []);

  const addNewInvoice = useCallback(() => {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`);
  }, [currModuleId, currModuleName, currUserMenu, navigate]);


  const searchByDate = useCallback(async () => {
    const formData = getValues();
    try {
      const response = await paymentMadeService.paymentMadeByDate(formData);
      if (response?.data?.length) {
        setTableData(response.data);
      } else {
        showToast("No result found", "");
        setTableData([]);
      }
    } catch (err) {
      showToast("Error", "error");
    }
  }, [getValues, showToast]);

  const handleRowClick = useCallback((data) => {
      const id = data["payment_ref_no"];
      navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`);
    },
    [currModuleId, currModuleName, currUserMenu, navigate]
  );



  const onClearInput = ()=> {
    setSearchText("");
    setTableData(getPaymentMadeAtom?.payment_info || []);

   }



  const handleSearch = (text) => {
    setSearchText(text);
   
     if (text.trim() === "") {
      setTableData(getPaymentMadeAtom?.payment_info || []);
       return;
     }
   
     const searchTerm = text.toLowerCase();
     const filtered = (getPaymentMadeAtom?.payment_info || []).filter(credit =>
       Object.values(credit).some(value => 
         value?.toString().toLowerCase().includes(searchTerm)
       )
     );
     setTableData(filtered); 
   };

  return (
    <>
  
      <div className="mt-6 md:flex items-end justify-between space-y-3 md:space-y-0">

        <div className="flex items-center space-x-2">
        <h2 className="text-2xl font-bold text-gray-800">Payment Made</h2>
          {/* {itemSelected.length > 0 ? (
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">Bulk Actions</Dropdown.Toggle>
              <Dropdown.Menu>
                {salesOrderData["Bulk_Action"]?.map((action, i) => (
                  <Dropdown.Item key={i} onClick={() => bulkActions(action)}>
                    {action.Action_Name}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          ) : (
            <SalesOrderFilter list={salesOrderData["Filtering_Criteria"]} onFilterSelect={onFilterSelect} />
          )} */}
          <Tooltip title="Reload">
            <div
              onClick={getPaymentMadeFromAPI}
              className="h-fit w-fit p-2 rounded-full cursor-pointer hover:bg-gray-200 active:bg-gray-300"
            >
              <IoMdRefresh className="h-[20px] w-[20px] text-gray-600" />
            </div>
          </Tooltip>
        </div>

        <div className="flex flex-row items-end space-x-2">
          <div>
            <span className="ml-1 text-sm">From Date:</span>
            <input
              defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
              {...register("from_date")}
              className="bg-white ring-1 ring-gray-200 w-full pl-3 rounded max-h-full outline-none border-transparent focus:border-transparent focus:ring-0"
              type="date"
            />
          </div>
          <div>
            <span className="ml-1 text-sm">To Date:</span>
            <input
              {...register("to_date")}
              defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
              className="bg-white ring-1 ring-gray-200 w-full pl-3 rounded max-h-full outline-none border-transparent focus:border-transparent focus:ring-0"
              type="date"
            />
          </div>
          <div>
            <button
              onClick={searchByDate}
              type="button"
              className="text-sm text-white px-3 bg-blue-500 rounded py-2.5"
            >
              Search
            </button>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          <Tooltip title="Add New">
            <button
              onClick={addNewInvoice}
              className="ml-2 h-fit w-fit px-3 py-2.5 bg-gray-200 border-[1.5px] border-gray-300 rounded-md text-white focus:outline-none font-medium hover:bg-gray-100 active:bg-gray-200 transition-all duration-200"
            >
              <FaPlus className="h-[16px] w-[16px] text-gray-600" />
            </button>
          </Tooltip>
        </div>

      </div>

                  {/* Start of search */}
    <div className="flex justify-center mt-4">
    <div className="flex flex-col w-full md:w-1/3">
      <input
        type="text"
        placeholder="Search in table"
        value={searchText}
        onKeyDown={(e) => {
          if (e.key === 'Backspace') {
            onClearInput();
          }
        }}
        onChange={(e) => handleSearch(e.target.value)}
        className="bg-white ring-1 ring-gray-200 w-full pl-3 py-2 rounded outline-none focus:ring-blue-300"
      />
    </div>
  </div>
  {/* End of search */}

      <section className="mt-5">
        <GeneralCustomTable
          tableHeadList={columns}
          tableDataList={tableData}
          allowCheckBox={true}
          setSelectedRows={selectedTableItems}
          rowKey={(record) => record.Sales_Order_Ref_No}
          handleRowClick={handleRowClick}
        />
      </section>
    </>
  );
};

export default React.memo(PaymentMadeMainPage); // Memoize component